import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "alert alert-warning" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "table table-hover" }
const _hoisted_9 = { class: "d-flex align-items-center mb-3" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "table table-hover" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = { class: "d-flex align-items-center mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ApplicationStateComponent = _resolveComponent("ApplicationStateComponent")!
  const _component_ModalTitle = _resolveComponent("ModalTitle")!
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModalBody = _resolveComponent("ModalBody")!
  const _component_ModalFooter = _resolveComponent("ModalFooter")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_MainOverviewContainer = _resolveComponent("MainOverviewContainer")!

  return (_openBlock(), _createBlock(_component_MainOverviewContainer, null, {
    title: _withCtx(() => [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('meta.pageTitles.overview')), 1)
    ]),
    content: _withCtx(() => [
      (_ctx.isLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (!_ctx.hasCurrentApplication)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('meta.pageTitles.overview')), 1),
                    _createElementVNode("div", _hoisted_3, [
                      (_ctx.isLoaded)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createTextVNode(_toDisplayString(_ctx.$t('text.no_current_application')) + " ", 1),
                            _hoisted_5,
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showRequestModal()), ["prevent"]))
                            }, _toDisplayString(_ctx.$t('text.request_application', { currentPeriod: _ctx.getApplicationPeriod(_ctx.currentApplicationPeriod) })), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('text.is_loading')), 1))
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('text.application')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('application.state')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('application.last_modified')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getReversedApplicationList(), (application) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: application.id + _ctx.activeLocale
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ApplicationOverview', params: { id: application.id }}
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.getApplicationPeriod(_ctx.periodList[application.application_period])), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_ApplicationStateComponent, {
                            state: application.state
                          }, null, 8, ["state"])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        (application.last_modified)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getDate(application.last_modified, _ctx.activeLocale)), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLoaded)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 1,
            ref: "requestApplicationModal",
            id: "requestApplicationModal",
            sizeClass: "modal-xl"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ModalHeader, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ModalTitle, {
                    title: _ctx.$t('text.request_new_application')
                  }, null, 8, ["title"])
                ]),
                _: 1
              }),
              _createVNode(_component_ModalBody, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('text.request_new_application_explanation')) + " ", 1),
                  _createElementVNode("table", _hoisted_12, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('application.application_period')), 1),
                        _createElementVNode("th", null, _toDisplayString(_ctx.$t('application.state')), 1),
                        _hoisted_13
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t('text.no_data')), 1),
                        _hoisted_14,
                        _createElementVNode("td", null, [
                          _createVNode(_component_Button, {
                            "btn-style": "btn-warning w-100",
                            "btn-type": "button",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.requestNewApplication(_ctx.currentApplicationPeriod.id)), ["prevent"]))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('text.request_without_copy')), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getReversedApplicationList(), (application) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: application.id + _ctx.activeLocale
                        }, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.getApplicationTime(_ctx.periodList[application.application_period], _ctx.activeLocale)), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_ApplicationStateComponent, {
                                state: application.state
                              }, null, 8, ["state"])
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_Button, {
                              "btn-style": "btn-secondary w-100",
                              "btn-type": "button",
                              onClick: _withModifiers(($event: any) => (_ctx.requestNewApplication(_ctx.currentApplicationPeriod.id, application.id)), ["prevent"])
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('text.request_with_copy')), 1)
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ModalFooter)
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}